import React from 'react';
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import * as rk from "../../localization/resourceKeys";
import i18n from "../../i18n";
import BottomLine from '../Footer/BottomLine';
import VCIConsumer from './customerTypes/vciConsumer';
import VCIB2B from './customerTypes/vciB2B';

const RightToCorrectVCI = ({stateSelector, country, language}) => {

    const history = useHistory();

    const dataCorrectionContent = (customerType) => {
      if (country.toLowerCase() === "canada") {
        const isWithdraw = history.location.pathname === '/withdraw'? true : false;
        return <VCIConsumer isWithdraw={isWithdraw} isCanada={true} language={language} />;
      }
      switch (customerType) {
        case i18n.t(rk.QUESTION_2_OPTION_1):
          return <VCIConsumer />;
        case i18n.t(rk.QUESTION_2_OPTION_3):
          return <VCIB2B />;
        default:
          history.push("/");
      }
    }

    return (
      <>
        {dataCorrectionContent(stateSelector.customerRelation)}
        <div className="request-footer-wrapper">
          <BottomLine />
        </div>
      </>
    );
};

const mapStateToProps = (state) => {
  return {
    country: state.initialReducer.country,
    language: state.initialReducer.language,
    stateSelector: state.stateSelector,
  };
};

 export default connect(mapStateToProps) (RightToCorrectVCI);